export default "<ion-app>\n  <app-sidemenu></app-sidemenu>\n  <ion-router-outlet id=\"sidemenu\"></ion-router-outlet>\n</ion-app>\n";